import { ListLoader } from "@/loaders";

export default {
  list: new ListLoader("/email-template-tags/for_school/", {
    setter: "emailTemplateTags/setTags",
  }),
};
